export const navInit = () => {
  const menuButton = document.querySelector(".header__menuButton");
  const menuClose = document.querySelector(".header__menuClose");
  const nav = document.querySelector(".header__nav");
  const container = document.querySelector(".header__container");
  const header = document.querySelector(".header");

  const toggleNav = () => {
    nav.classList.toggle("is-active");
    container.classList.toggle("is-active");
  };

  if (menuButton && menuClose && nav && container) {
    menuButton.addEventListener("click", toggleNav);
    menuClose.addEventListener("click", toggleNav);

    // Add event listeners to nav links
    const navLinks = document.querySelectorAll(".header__navLink");
    navLinks.forEach((link) => {
      link.addEventListener("click", () => {
        if (nav.classList.contains("is-active")) {
          toggleNav();
        }
      });
    });
  }

  if (header) {
    let lastScrollTop = 0;
    const hideThreshold = 100; // Threshold for hiding header on scroll down
    const heroIntro = document.querySelector(".heroSec__intro01");

    // Function to check if we've scrolled past the trigger element
    const shouldShowBackground = () => {
      if (!heroIntro) return window.pageYOffset > 10; // Fallback if element not found
      const heroRect = heroIntro.getBoundingClientRect();
      // Show background when the top of heroSec__intro01 reaches the top of the viewport
      return heroRect.top <= 0;
    };

    // Set initial state based on current scroll position
    if (shouldShowBackground()) {
      header.classList.add("is-scrolled");
    }

    window.addEventListener("scroll", () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const isNavActive = nav && nav.classList.contains("is-active");

      // Toggle background transparency based on heroSec__intro01 position
      if (shouldShowBackground()) {
        header.classList.add("is-scrolled");
      } else {
        header.classList.remove("is-scrolled");
      }

      if (isNavActive) return;

      // Hide/show header on scroll direction
      if (scrollTop > lastScrollTop && scrollTop > hideThreshold) {
        header.classList.add("is-hidden");
      } else {
        header.classList.remove("is-hidden");
      }
      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    });
  }
};
